module.exports = __webpack_public_path__ + "img/contact.d6e6616b.png";